export const filterAdResponse = (htmlAd: string) => {
  const invalidPrefix = "<a href";
  if (htmlAd.startsWith(invalidPrefix)) {
    return "";
  }
  return htmlAd;
};
